import React from 'react';
import { Heading, PageWrap, ContentSection, Paragraph, ButtonContainer, Button } from '@vwfs-bronson/bronson-react';
import { useTranslation } from 'react-i18next';
import { trackingService } from '../../tracking/tracking.service';

const retailerLinks = [
  { name: 'audi', url: 'https://www.audi.co.uk/uk/web/en/locate-a-centre.html' },
  { name: 'vw', url: 'https://www.volkswagen.co.uk/en/find-a-volkswagen-retailer.html' },
  { name: 'vwfs', url: 'https://www.volkswagen.co.uk/en/find-a-volkswagen-retailer.html' },
  { name: 'seat', url: 'https://www.seat.co.uk/car-dealers-locator.html' },
  { name: 'vwcv', url: 'https://www.volkswagen-vans.co.uk/en/find-a-volkswagen-van-centre.html' },
  { name: 'skoda', url: 'https://retailers.skoda-auto.com/210/en-gb' },
  { name: 'porsche', url: 'https://www.porsche.com/uk/dealersearch/' },
  { name: 'bentley', url: 'https://www.bentleymotors.com/en/apps/dealer-locator' },
  { name: 'lamborghini', url: 'https://www.lamborghini.com/en-en/dealerships?#showroom' }
];

const brand = process.env.REACT_APP_WEBSITE_BRAND;
const retailerUrl = retailerLinks.find(item => item.name.toLowerCase() === brand?.toLowerCase())?.url;

const ErrorPage: any = () => {
  const { t } = useTranslation();

  React.useEffect(() => {
    trackingService.trackPageView('Error page', 'Error page');
  }, []);

  const retailerButtonClick = () => {
    window.open(retailerUrl, '_self');
  };

  return (
    <PageWrap>
      <ContentSection className="u-text-center">
        <Heading level={3}>{t('errorPage:errorPage:heading')}</Heading>
        <Paragraph>{t('errorPage:errorPage:subHeading')}</Paragraph>
        <Paragraph>{t('errorPage:errorPage:content')}</Paragraph>
      </ContentSection>
      <ButtonContainer center>
        <Button onClick={retailerButtonClick}>{t(`errorPage:errorPage:brandButton:${brand}`)}</Button>
      </ButtonContainer>
    </PageWrap>
  );
};

export default ErrorPage;
